import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface TaskAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.wishLists.edit

function* editWishListsSagaTask({ payload }) {
    try {
        const response = yield axios.put(`/companies/wish-lists/${payload.id}`, { ...payload.data })
        if (response.success) {
            yield put(onSuccess(response.result))
        } else {
            yield put(onFailure(''))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* editWishListsSaga(): any {
    yield takeLatest<TaskAction>(onRequest, editWishListsSagaTask)
}

export default editWishListsSaga
